import React, { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Unstable_Grid2";
import { TextField, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import OrderTypeEdit from "./OrderTypeEdit";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { addCommas } from "@persian-tools/persian-tools";
import DeleteOrderType from "./DeleteOrderType";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const OrderTypeCarding = (props) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const handleEditModalOpen = () => setEditModalOpen(true);
  const handleEditModalClose = () => setEditModalOpen(false);
  const handleDeleteModalOpen = () => setDeleteModalOpen(true);
  const handleDeleteModalClose = () => setDeleteModalOpen(false);

  return (
    <React.Fragment>
      <Modal open={editModalOpen} onClose={handleEditModalClose}>
        <Box sx={style}>
          <OrderTypeEdit
            id={props.id}
            name={props.name}
            unitPrice={props.unitPrice}
            oneJawPrice={props.oneJawPrice}
            twoJawPrice={props.twoJawPrice}
            close={handleEditModalClose}
            open={editModalOpen}
          />
        </Box>
      </Modal>
      <Modal open={deleteModalOpen} onClose={handleDeleteModalClose}>
        <Box sx={style}>
          <DeleteOrderType id={props.id} close={handleDeleteModalClose} />
        </Box>
      </Modal>

      <Grid container spacing={1}>
        <Grid md={12}>
          <Card sx={{ minWidth: 80, height: 300 }}>
            <CardContent>
              <Grid container spacing={0.5}>
                <Grid xs={12}>
                  <TextField
                    fullWidth
                    value={props.name}
                    variant="standard"
                    label="نام"
                    inputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid xs={12}>
                  <TextField
                    fullWidth
                    value={addCommas(props.unitPrice)}
                    variant="standard"
                    label="هر واحد"
                    inputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid xs={12}>
                  <TextField
                    fullWidth
                    value={addCommas(props.oneJawPrice)}
                    variant="standard"
                    label="یک فک"
                    inputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid xs={12}>
                  <TextField
                    fullWidth
                    value={addCommas(props.twoJawPrice)}
                    variant="standard"
                    label="دو فک"
                    inputProps={{ readOnly: true }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid xs={12}>
          <Button
            size="small"
            fullWidth
            variant="contained"
            onClick={handleEditModalOpen}
          >
            <EditIcon />
          </Button>
        </Grid>
        <Grid xs={12}>
          <Button
            size="small"
            fullWidth
            color="error"
            variant="outlined"
            sx={{ mb: 1 }}
            onClick={handleDeleteModalOpen}
          >
            <DeleteIcon />
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default OrderTypeCarding;
